import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import Link from "gatsby-link"

interface IProps {
  currentPage: number
  numPages: number
}

const Pagination = ({ currentPage, numPages }: IProps) => {
  const getPrevPage = () => {
    switch (currentPage) {
      case 2:
        return `/content`
      case 1:
        return null
      default:
        return `/content/${currentPage - 1}`
    }
  }

  const getNextPage = () => {
    if (numPages >= currentPage + 1) {
      return `/content/${currentPage + 1}`
    } else {
      return null
    }
  }

  const prev = getPrevPage()
  const next = getNextPage()
  return (
    <nav className={styles.pagination} role="navigation">
      {prev && (
        <Link
          className={cx({
            [styles.prev]: true,
            [styles.link]: true,
          })}
          to={prev}
        >
          <span
            className={cx({
              [styles.arrow]: true,
              ["bsk-icon-arrow-stick-left-thicker"]: true,
            })}
          ></span>
          <span>Previous</span>
        </Link>
      )}
      <span className={styles.pageNumber}>
        Page {currentPage} of {numPages}
      </span>
      {next && (
        <Link
          className={cx({
            [styles.next]: true,
            [styles.link]: true,
          })}
          to={next}
        >
          <span>Next</span>
          <span
            className={cx({
              [styles.arrow]: true,
              ["bsk-icon-arrow-stick-right-thicker"]: true,
            })}
          ></span>
        </Link>
      )}
    </nav>
  )
}

export default Pagination
